import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import 'react-toastify/dist/ReactToastify.css';
import { API_URLS } from '../constants/apiUrl';
import { useLoading } from '../context/LoadingContext';
import { post } from '../api/api';
import { INote } from '../interface/notes';
import { showToast } from '../components/utils/toast';
type CreateNoteAttachmentWithParams = {
  notesId: string;
  data: FormData;
  params?: Record<string, string>;
};
const createNoteAttachment = async ({
  notesId,
  data,
}: CreateNoteAttachmentWithParams): Promise<INote> => {
  return post(`${API_URLS.DELETE_NOTES_ATTACHMENT.replace(':id', notesId)}`, data, {
    skipGlobalErrorHandler: true,
  });
};

export const useCreateNoteAttachment = (): UseMutationResult<
  INote,
  AxiosError<{ message?: string; type?: string }>,
  CreateNoteAttachmentWithParams
> => {
  const { setIsLoading } = useLoading();

  return useMutation({
    mutationFn: createNoteAttachment,
    onMutate: () => {
      setIsLoading(true);
    },
    onError: (error) => {
      showToast('error', error.message);
    },
    onSettled: () => {
      setIsLoading(false);
    },
  });
};
